import { useRef, useState, useEffect, useMemo } from "react";
import Slider from "react-slick";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import sanityClient from "../../sanityClient";

export default function HomeStories() {
  const sliderRef = useRef(null);
  const [stories, setStories] = useState([]);
  const [homeContent, setHomeContent] = useState({
    title: "",
    heading1: "",
    heading2: "",
    heading3: "",
    heading4: "",
  });

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const homeData = await sanityClient.fetch(
          `*[_type == "homePageContent"][0].homeclientexperience{title, heading1, heading2, heading3, heading4}`
        );
        setHomeContent(homeData);

        const storyData = await sanityClient.fetch(
          `*[_type == "story"]{
            text,
            authorName,
            authorDescription,
            "imageUrl": image.asset->url,
            "altText": image.alt
          }`
        );
        setStories(storyData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchContent();
  }, []);

  const sliderSettings = useMemo(
    () => ({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 1400,
      autoplaySpeed: 4000,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      pauseOnHover: false,
      cssEase: "ease",
      responsive: [
        { breakpoint: 991, settings: { slidesToShow: 2 } },
        { breakpoint: 767, settings: { slidesToShow: 1 } },
        { breakpoint: 599, settings: { slidesToShow: 1 } },
      ],
    }),
    []
  );

  const CustomArrows = () => (
    <div className="portfo-arrows">
      <button className="default-arrowleft" onClick={() => sliderRef.current.slickPrev()}>
        <FontAwesomeIcon icon={faArrowLeft} />
      </button>
      <button className="default-arrowright" onClick={() => sliderRef.current.slickNext()}>
        <FontAwesomeIcon icon={faArrowRight} />
      </button>
    </div>
  );

  return (
    <section className="home-story" >
      <div className="container">
        <div className="row">
          <div className="col-lg-12 quality-grid">
            <div className="row quality-row">
              <div className="col-lg-6">
                <div className="storyarea-head">
                  <img src="./assets/home/choose-icon-4.png" alt="icon" />
                  <h4 className="heading">{homeContent.title}</h4>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="storyarea-point">
                  {[homeContent.heading1, homeContent.heading2, homeContent.heading3, homeContent.heading4].map(
                    (heading, index) =>
                      heading && (
                        <div key={index}>
                          <img src="/assets/home/star.png" alt="Star" />
                          <p>{heading}</p>
                        </div>
                      )
                  )}
                </div>
              </div>

              <div className="col-lg-12">
                <Slider className="story-slider" ref={sliderRef} {...sliderSettings}>
                  {stories.map((story, index) => (
                    <div className="story-slidebox" key={index}>
                      <img
                        src={story.imageUrl}
                        className="img-responsive"
                        alt={story.altText || "Story Image"}
                        loading="lazy"
                        width="100%"
                        height="100%"
                      />
                      <div>
                        <p>{story.text}</p>
                        <span>{story.authorName}</span>
                        <small>{story.authorDescription}</small>
                      </div>
                    </div>
                  ))}
                </Slider>
                <CustomArrows />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
